import { MessageProperty } from './message-property';

export class Message {
  Id: string;
  ConnectionId: number;
  SequenceNumber: number;
  Size: number;
  EnqueuedAt: Date;
  Body: string
  UserProperties: MessageProperty[];
}
